// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__35QlA","title":"AfterFrontImage_title__1_EE-"};